 
import { Col, Container, Row } from "reactstrap";
import { LuxuryCars } from "../../../../constants";
import { BrandFlexData, ChallengeContent, LuxuryCarsContent, OurApproachContent, ResultsAndImpactContent, SolutionContent } from "../../../../data/pages/Portfolio";
import { routes } from "../../../../routers/routes";
import { dynamicImage } from "../../../../utils";
import RatioImage from "../../../../utils/RatioImage";
import Breadcrumbs from "../../../commonComponents/breadcrumbs";
import PortfolioDetailContent from "./common/PortfolioDetailContent";

const PortfolioDetail2Container = () => {
  return (
    <>
      <Breadcrumbs title="Portfolio" url={routes.Home.CarDemo1} mainClass="page-breadcrumbs-section" />
      <section className="section-b-space portfolio-detail-section dark-portfolio">
        <Container>
          <div className="top-section section-b-space ratio_45">
            <Row>
              <Col lg="8" className="ratio_65">
                <div className="main-top-image">
                  <RatioImage src={dynamicImage("portfolio/detail-images/1.jpg")} alt="pd-1" className="img-fluid bg-img" />
                </div>
              </Col>
              <Col lg="4">
                <div className="right-portfolio-image ratio_65">
                  <div className="portfolio-content-box">
                    <span className="border-bg" />
                    <h3>{LuxuryCars}</h3>
                    <p>{LuxuryCarsContent}</p>
                  </div>
                  <div className="sub-top-image">
                    <RatioImage src={dynamicImage("portfolio/detail-images/4.jpg")} alt="pd-2" className="img-fluid bg-img" />
                  </div>
                </div>
              </Col>
            </Row>
            <div className="brand-flex">
              {BrandFlexData.map((item, index) => (
                <span key={index}>
                  <strong>{item.title}: </strong>
                  {item.text}
                </span>
              ))}
            </div>
          </div>
          <PortfolioDetailContent title="The Challenge" image="2" data={ChallengeContent} dark />
          <PortfolioDetailContent title="Our Approach" image="3" data={OurApproachContent} rightSide dark />
          <PortfolioDetailContent title="The Solution" image="4" data={SolutionContent} dark />
          <PortfolioDetailContent title="Results & Impact" image="5" data={ResultsAndImpactContent} rightSide dark />
        </Container>
      </section>
    </>
  );
};

export default PortfolioDetail2Container;
